export default __webpack_public_path__ + "static/media/download-invoice.8b7d2d25.svg";